module.exports = __webpack_public_path__ + "img/data-money.a039c9a8.svg";